@use 'style/utils';

$CLASS: '.joy-bottom-sheet';

#{$CLASS} {
    z-index: 30;

    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 0;
    box-sizing: border-box;
    @include utils.getFontProperties(primary-400);
    color: var(--joy-color-neutral-60);

    transition-property: background-color, height;
    transition-duration: 0.6s, 0s;
    transition-delay: 0s, 0.6s;

    #{$CLASS}-container {
        z-index: 2;

        position: fixed;
        bottom: -100%;
        left: 0;

        width: 100%;
        box-sizing: border-box;

        margin: 0;
        padding: 0;

        border-radius: 20px 20px 0 0;
        box-shadow: 0 8px 32px rgba(24, 24, 24, 0.24);

        background: #FFF;

        transition-property: bottom;
        transition-duration: 0.6s;

        user-select: none;

        &.moving {
            transition: none;
        }

        #{$CLASS}_footer {
            display: flex;
            padding: 16px;

            border-top: 1px solid var(--joy-color-secondary-10);

            #{$CLASS}_footer-close {
                margin: 0 auto;
                width: 100%;
            }

            ::slotted(*) {
                width: 100%;
            }

            ::slotted(joy-wrapper) {
                margin: 0;
                --wrapper-gap: var(--joy-core-spacing-4);
            }
        }

        #{$CLASS}_content {
            padding: 0 16px 16px 16px;

            max-height: 60vh;
            overflow-y: auto; // if > 60vh

            h2 {
                text-align: justify;
            }

            p {
                text-align: justify;
            }
        }

        #{$CLASS}_header {
            padding: 16px;

            #{$CLASS}_header-close {
                height: 6px;
                width: 36px;

                margin: 0 auto;

                background-color: var(--joy-color-neutral-30);
                border-radius: 100px;

                cursor: grabbing;
            }
        }
    }

    &--open {
        transition-delay: 0s;

        height: 100%;
        background-color: var(--joy-color-overlay);

        #{$CLASS}-container {
            bottom: 0;
        }
    }
}
